import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BaseHeader;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import { ItemBanksButton } from '../ItemBanksButton';
import { PreviewButton } from '../PreviewButton';
import { OutcomesEditButton } from '../OutcomesEditButton';
import { OutcomesEditPanel } from '../OutcomesEditPanel';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { END_EDITING_TRIGGER_CLASSNAME, withStyleOverrides } from '@instructure/quiz-common';
export var BaseHeader = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BaseHeader = /*#__PURE__*/function (_Component) {
  function BaseHeader() {
    _classCallCheck(this, BaseHeader);
    return _callSuper(this, BaseHeader, arguments);
  }
  _inherits(BaseHeader, _Component);
  return _createClass(BaseHeader, [{
    key: "renderButtons",
    value: function renderButtons() {
      var _this = this;
      var buttons = [];
      var _this$props = this.props,
        itemBanksButtonRef = _this$props.itemBanksButtonRef,
        onItemBanksClick = _this$props.onItemBanksClick,
        outcomesEndpoint = _this$props.outcomesEndpoint,
        outcomesToken = _this$props.outcomesToken,
        onPreviewClicked = _this$props.onPreviewClicked,
        isEditing = _this$props.isEditing,
        quiz = _this$props.quiz;
      if (onItemBanksClick && itemBanksButtonRef) {
        buttons.push({
          key: 'item_banks',
          component: jsx(ItemBanksButton, {
            instUiButtonRef: itemBanksButtonRef,
            onClick: onItemBanksClick
          })
        });
      }
      if (outcomesEndpoint) {
        buttons.push({
          key: 'outcome_alignments',
          component: jsx(OutcomesEditButton, {
            quiz: quiz,
            contextUuid: this.props.contextUuid,
            outcomesEndpoint: outcomesEndpoint,
            outcomesToken: outcomesToken,
            guid: "outcomes-edit",
            "data-automation": "sdk-header-outcomes-edit-button"
          })
        });
      }
      if (onPreviewClicked) {
        buttons.push({
          key: 'quiz_preview',
          component: jsx(PreviewButton, {
            onClick: onPreviewClicked,
            isEditing: isEditing,
            hasQuestions: this.props.quiz.hasQuestions()
          })
        });
      }
      if (buttons.length > 0) {
        return jsx("div", {
          css: this.props.styles.buttons
        }, buttons.map(function (_ref) {
          var key = _ref.key,
            component = _ref.component;
          return jsx("div", {
            key: key,
            css: _this.props.styles.button,
            className: END_EDITING_TRIGGER_CLASSNAME
          }, component);
        }));
      } else {
        return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.headerRows
      }, jsx("div", {
        css: this.props.styles.headerRow
      }, jsx(Heading, {
        level: "h1"
      }, t('Build')), this.renderButtons()), this.props.outcomesEndpoint ? jsx(OutcomesEditPanel, {
        quiz: this.props.quiz,
        contextUuid: this.props.contextUuid,
        outcomesEndpoint: this.props.outcomesEndpoint,
        outcomesToken: this.props.outcomesToken,
        guid: "outcomes-edit"
      }) : null);
    }
  }]);
}(Component), _defineProperty(_BaseHeader, "displayName", 'BaseHeader'), _defineProperty(_BaseHeader, "componentId", "Quizzes".concat(_BaseHeader.displayName)), _defineProperty(_BaseHeader, "propTypes", {
  quiz: ImmutablePropTypes.record.isRequired,
  contextUuid: PropTypes.string,
  outcomesEndpoint: PropTypes.string,
  outcomesToken: PropTypes.string,
  onItemBanksClick: PropTypes.func,
  itemBanksButtonRef: PropTypes.func,
  onPreviewClicked: PropTypes.func,
  isEditing: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_BaseHeader, "defaultProps", {
  contextUuid: null,
  outcomesEndpoint: null,
  outcomesToken: null,
  onItemBanksClick: null,
  itemBanksButtonRef: null,
  onPreviewClicked: null,
  isEditing: false
}), _BaseHeader)) || _class);
export default BaseHeader;